import React, { Component } from 'react';
import { addMultipleListeners, swipeEnd, swipeStart, swipeMove } from '../Services/SwipeEvents';
import { showIndexScreen } from '../Helpers/Screen';
import Header from "../Header/Header"
import Footer from "../Footer/Footer"
import MainScreen from '../Screen/MainScreen';
import VoteScreen from '../Screen/VoteScreen';
import { interstitial } from '../Services/Adsense/ads';
import Popup from '../Common/Popup/Popup';
import { vPush } from '../Services/Analytics';
import _Content from "../../static/data/content.json";
import { groupBy } from "../Services/Array";
import FinalEnd from '../FinalEnd/FinalEnd';
import GenericEnd from '../Screen/GenericEnd';
import { throwPopupEvent } from '../Services/Timing';
import { handleVote } from '../Services/Storage';
const __Categories__ = groupBy(_Content, g => g.Category);

class App extends Component {
  constructor(props) {
    super();
    this.setCurrentScreen = this.setCurrentScreen.bind(this);
    this.state = {
      slideShowCSS: {},
      isBusy: false,
      mainScreen: {
        CSS: {},
        isBusy: false,
        isActive: false
      },
      isEnded: false
    }
  }
  componentDidMount() {
    addMultipleListeners(window.document, "mousewheel DOMMouseScroll", (event) => showIndexScreen(event, this.setCurrentScreen))
    addMultipleListeners(window.document, "swd swu", (event) => showIndexScreen(event, this.setCurrentScreen))


    if (this.state.isEnded) {
      throwPopupEvent({
        Type: "Message",
        ClassName: "thanks",
        Head: "זהו, הסתיים!",
        Desc: "תוצאות הפעילות ממש בקרוב",
        showInsta: true
      });
    } else {
      if (handleVote.get("isVoted2019")) {
        throwPopupEvent({
          Type: "Message",
          ClassName: "thanks voted",
          Head: "אופס...",
          Desc: "לא ניתן להצביע יותר מפעם אחת",
          showInsta: true,
          // refresh: true
        });
      }
    }
  }
  setCurrentScreen(state) {
    if (this.state.mainScreen.isBusy) return;
    this.setState({
      mainScreen: {
        ...this.state.mainScreen,
        ...state
      }
    }, () => {
      this.setState({
        mainScreen: {
          ...this.state.mainScreen,
          isBusy: false
        }
      })
    })
    if (this.state.mainScreen.isActive && !this.state.isBusy) {
      let i = 0;
      __Categories__.forEach(obj => {
        if (i == 0) {
          // vPush(`${obj[0].Category}`, `${window.location.pathname}Category-0`);
        }
        i++;
      });
      this.setState({
        isBusy: true
      })
    }
  }
  render() {
    if(handleVote.get("isVoted2019") || this.state.isEnded) {
      return (
        <div className="App">
          <main className="main-wrapper">
            <Header />
              <div className={`screen-switcher`}>
              <div className="main-screen"
                style={this.state.slideShowCSS}
                ref={(mainScreen) => this.mainScreen = mainScreen}>
                <Popup />
                <GenericEnd slideDwon={this.setCurrentScreen} />
              </div>
              <div className="section-screen"
                ref={(sectionScreen) => this.sectionScreen = sectionScreen}>
                <Popup />
                <VoteScreen init={this.state.mainScreen.isActive} />
              </div>
            </div>
          </main>
          <Footer isActive={false} />
        </div>);
    }
    return (
      <div className="App">
        <main className="main-wrapper">
          <Header />
          <div className={`screen-switcher ${this.state.mainScreen.isActive ? " vote-screen" : ""}`}>
            <div className="main-screen"
              style={this.state.slideShowCSS}
              ref={(mainScreen) => this.mainScreen = mainScreen}>
              <Popup />
              <MainScreen slideDwon={this.setCurrentScreen} />
            </div>
            <div className="section-screen"
              ref={(sectionScreen) => this.sectionScreen = sectionScreen}>
              <Popup />
              <VoteScreen init={this.state.mainScreen.isActive} />
            </div>
          </div>
        </main>
        <Footer isActive={this.state.mainScreen.isActive} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Components/App/App.jsx